var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAsTraderLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32577 6.4502H18.6757C19.9668 6.4502 21.0132 7.49656 21.0132 8.78768V11.1252H2.98828V8.78768C2.98828 7.49656 4.03465 6.4502 5.32577 6.4502Z",
    stroke: "#02B27F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6757 22.25H5.32577C4.03465 22.25 2.98828 21.2036 2.98828 19.9125V13.125H21.0132V19.9125C21.0132 21.2036 19.9668 22.25 18.6757 22.25Z",
    stroke: "#F2AE00",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 3.22499C12.0008 3.68557 12.0008 5.44999 12.0008 5.44999C12.0008 5.44999 10.5434 5.44999 9.77577 5.44999C8.54647 5.44999 7.55078 4.4543 7.55078 3.22499C7.55078 1.99568 8.54647 1 9.77577 1C11.0051 1 12.0008 1.99568 12.0008 3.22499Z",
    fill: "#02B27F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.22499C12 3.68557 12 5.44999 12 5.44999C12 5.44999 13.4574 5.44999 14.225 5.44999C15.4543 5.44999 16.45 4.4543 16.45 3.22499C16.45 1.99568 15.4543 1 14.225 1C12.9957 1 12 1.99568 12 3.22499Z",
    fill: "#02B27F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsTraderLight);
export default __webpack_public_path__ + "static/media/as_trader_light.d69719bfb7655fa22095340cb3db6cd7.svg";
export { ForwardRef as ReactComponent };